import NotificationsFollowButton from './NotificationsFollowButton'

export default NotificationsFollowButton
// eslint-disable-next-line import/export
export * from './NotificationsFollowButton'
